import { isConfigEnabled } from '@/config/config';
/**
 * Feature Manager:
 * Service to manage the available features of the application controlled by feature flags.
 * Flags are defined in application config.
 */
class FeatureManagerService {
    public useBpFeature(): boolean {
        return isConfigEnabled("REACT_APP_BP_BUILD");
    };
    public canUseONYXData(): boolean {
        return isConfigEnabled("REACT_APP_USE_ONYX_DATA");
    };
    public canUseVBLFeature(): boolean {
        return isConfigEnabled("REACT_APP_USE_VBL");
    };
    public canManageVBLRecords(): boolean {
        return isConfigEnabled("REACT_APP_USE_VBL_RECORD_MGMT");
    };
};

export const featureManager = new FeatureManagerService();